import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import { Modal, device } from 'utils';
import styled from '@emotion/styled';
import { PaymentActions } from 'redux/actions';
import { InfoCardForm } from './InforCardForm';
import PaymentMethod from '../PaymentMethod/PaymentMethod';

const InfoFormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${device.allMobile} {
    gap: 24px;
    margin-top: 0;
  }
`;

const PaymentSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;

const SecurityNote = styled.div`
  display: flex;
  align-items: center;
  min-height: 46px;
  padding: 14px 16px;
  background: #def7ec;
  border-radius: 8px;

  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
`;

const PaymentCardWrapper = styled.div`
  width: 100%;
`;

const ModalContent = styled.div`
  padding: 8px 0;
`;

export class InfoForm extends Component {
  static propTypes = {
    setCurrentViewState: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired,
    tips: PropTypes.number.isRequired,
    selectedCard: PropTypes.object.isRequired,
    card: PropTypes.object.isRequired,
    makeDonation: PropTypes.func.isRequired,
    projectId: PropTypes.string.isRequired,
    project: PropTypes.object.isRequired,
    supportLevelId: PropTypes.string,
    donationFormRef: PropTypes.object.isRequired,
    addressRequired: PropTypes.bool.isRequired,
    embeddedAction: PropTypes.bool,
    selectedRewards: PropTypes.any.isRequired,
    clientSecret: PropTypes.any,
    handleCLientSecret: PropTypes.func.isRequired,
    onProcessingChange: PropTypes.func,
    showSummary: PropTypes.bool.isRequired,
  };

  state = {
    paymentMethods: null,
    showModal: false,
    loading: false,
    paymentData: null,
    countryValue: '',
  };

  handleChange = (value) => {
    this.setState({
      paymentMethods: value,
    });
  };

  handleCard = () => {
    this.setState({
      paymentType: 'card',
    });
  };

  handlePayPal = () => {
    this.setState({
      paymentType: 'payPal',
    });
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handleCountryChange = (countryValue) => {
    this.setState({
      countryValue,
    });
  };


  render() {
    const { showModal, loading, paymentData } = this.state;
    const {
      amount,
      tips,
      projectId,
      selectedRewards,
      project,
      embeddedAction,
      onProcessingChange,
      supportLevelId,
    } = this.props;


    return (
      <Spin spinning={loading}>
        <InfoFormWrapper>
          <PaymentSection>
            <PaymentCardWrapper>
              <PaymentMethod
                supportLevelId={supportLevelId}
                project_id={projectId}
                amount={amount}
                tips={tips}
                paymentData={paymentData}
                selectedRewards={selectedRewards}
                project={project}
                embeddedAction={embeddedAction}
                onProcessingChange={onProcessingChange}
                showSummary={this.props.showSummary}
              />
            </PaymentCardWrapper>
          </PaymentSection>
        </InfoFormWrapper>

        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <ModalContent>
            <InfoCardForm setCurrentView={() => this.handelCloseModal()} />
          </ModalContent>
        </Modal>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const { card, selectedCard, donation, loading, errors } = state.payment;
  return {
    selectedCard,
    loading,
    errors,
    donation,
    card,
  };
};

const mapDispatchToProps = (dispatch) => ({
  makeDonation: (donation) => dispatch(PaymentActions.makeDonation(donation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoForm);
